import { createContext, useContext } from "react";

export const ThemeContext = createContext({ darkMode: false, toggleDark: () => {}, fontScale: "normal", setFontScale: () => {} });
export function useTheme() { return useContext(ThemeContext); }
